import { storyblokEditable } from "@storyblok/react/rsc";

import { RichTextField } from "@/components/typography/RichTextField";

type InfoTextStoryblok = {
  text: string;
  _uid: string;
  component: "info_text";
  [k: string]: any;
};

type InfoTextProps = {
  blok: InfoTextStoryblok;
};

const InfoText = ({ blok }: InfoTextProps) => {
  if (!blok.text) return null;

  return (
    <RichTextField value={blok.text} className="text-copy" {...storyblokEditable(blok)} />
  );
};

export default InfoText;
